/**
 * 화면 문구 번역 헬퍼 — 훅이 아니라 어디서나 부를 수 있다.
 *
 *   tt("a.1a2b3c4d", "신청 가능")            → 현재 언어의 번역, 없으면 두 번째 인자(한국어 원문)
 *   tt("a.…", "작품 {{v0}}건", { v0: n })    → 자리표시자 치환
 *
 * 사전에 키가 없으면 **한국어 원문이 그대로** 나오므로, 번역이 밀려도 화면은 깨지지 않는다.
 * 훅이 아니어서 언어를 바꿔도 스스로 다시 그리지 않는다 — `LanguageBoundary`(src/App.jsx)가
 * 언어를 key 로 잡아 전체를 다시 마운트한다.
 */
import i18n from "./index";
import dataEn from "./locales/data.en.json";
import dataJa from "./locales/data.ja.json";
import dataZh from "./locales/data.zh.json";

/** 데이터로도 쓰이는 라벨(등급명·카테고리·채널 유형 등)의 **표시용** 사전. 값 자체는 바꾸지 않는다. */
const DATA_LABELS = { en: dataEn, ja: dataJa, zh: dataZh };

export function tt(key, defaultValue, vars) {
  return i18n.t(key, { defaultValue, ...(vars || {}) });
}

export default tt;

/**
 * 데이터 라벨을 화면에 보여줄 때만 옮긴다 — `ttl("드라마")` → "Drama".
 * DB 값·비교에 쓰이는 문자열 자체는 그대로 둔 채 표시만 바꾸는 용도다.
 * 사전에 없으면 원문을 그대로 돌려준다.
 */
export function ttl(koText) {
  if (!koText) return koText;
  const table = DATA_LABELS[i18n.language];
  return (table && table[koText]) || koText;
}

/**
 * 문장 한가운데 **링크 같은 JSX 요소**가 들어가야 할 때 — 자리표시자 앞뒤 글자를 돌려준다(2026-09-07 전수 검수).
 *   const [before, after] = ttAround("a.x", "{{v0}}에 동의합니다.");   // ko: ["", "에 동의합니다."], en: ["I agree to the ", "."]
 *   <>{before}<Link>이용약관</Link>{after}</>
 * 종전에는 「링크 + 뒤 조각」만 이어 붙여 영어에서 "Terms of ServiceI agree to the" 가 됐다.
 */
export function ttAround(key, defaultValue, vars, slot = "v0") {
  const marker = "\u0000";
  const full = tt(key, defaultValue, { ...(vars || {}), [slot]: marker });
  const i = full.indexOf(marker);
  if (i < 0) return [full, ""];
  return [full.slice(0, i), full.slice(i + marker.length)];
}
